<template>
  <div>
    <div class="fr ac jsb">
      <span>我的同事</span>
      <el-button type="text" v-if="hasPermission(904)" @click="go('/me/workmate/add')">添加同事</el-button>
    </div>
    <el-table class="mt30" :data="workmate_list" style="width: 100%">
      <el-table-column align="center" label="头像" width="180">
        <template slot-scope="scope">
          <div class="fr jc ac">
            <el-image class="member-img fr ac jc" :src="scope.row.member_img">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="member_nick_name" label="昵称" width="180"></el-table-column>
      <el-table-column align="center" prop="member_account" label="电话"></el-table-column>
      <el-table-column align="center" label="职位">
        <template slot-scope="scope">
          <div class="fr jc ac">
            <div>{{ scope.row.memberRoleBean.roleBean.role_name }}</div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
          v-if="hasRole([10,11])"
          align="center"
          label="编辑"
      >
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" v-if="hasPermission(902)" type="text" @click="updateMemberRole(scope.row)">编辑
          </el-button>
          <el-button icon="el-icon-delete" v-if="hasPermission(903)" type="text"
                     @click="deleteMember(scope.row.auth_id)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>


    <!--        指派职位弹窗-->
    <el-dialog center title="提示" :visible.sync="update_role_show" width="30%">
      <div class="fc jc ac">
        <img
            :src="current_member.member_img"
            style="width: 100px;height: 100px;border-radius: 50%"
            alt
        />
        <div class="mt10">{{ current_member.member_nick_name }}</div>
        <div class="mt10">{{ current_member.member_account }}</div>

        <div class="fr ac mt50">
          <div>职位</div>
          <div class="ml20">
            <el-select v-model="update_form.role_id" placeholder="请选择">
              <el-option
                  v-for="item in role_list"
                  :key="item.role_id"
                  :label="item.role_name"
                  :value="item.role_id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="fr jc ac mt50">
        <el-button @click="submitUpdate" class="mt30" type="primary" style="width: 168px">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      memberInfo: this.$store.state.memberInfo,
      //指派职位弹窗
      update_role_show: false,
      //当前选中指派职位的人
      current_member: {},
      //修改权限表单
      update_form: {
        auth_id: "",
        role_id: ""
      },
      //角色列表
      role_list: [],
      workmate_list: []
    };
  },
  mounted() {
    this.getWorkMateList();
    this.getMemberRoleList();
  },
  methods: {
    //    获取同事列表
    getWorkMateList() {
      let auth_type = "";
      let relation_id = "";

      if (this.hasMemberType(2)) {
        auth_type = 2;
        relation_id = this.memberInfo.company_id;
      }

      if (this.hasMemberType(3)) {
        auth_type = 3;
        relation_id = this.memberInfo.merchants_id;
      }

      if (this.hasMemberType(4)) {
        auth_type = 4;
        relation_id = -1;
      }

      let param = {
        auth_type: auth_type,
        relation_id: relation_id
      };
      this.post("memberRoleInterfaces/v1.0/getCompanyWorkmateList", param).then(
          res => {
            this.workmate_list = res.data;
          }
      );
    },
    //    删除同事
    deleteMember(auth_id) {
      this.$confirm("是否确认删除同事", "提示").then(() => {
        let param = {
          auth_id: auth_id
        };

        this.post("memberInterfaces/v1.0/deleteMemberAuth", param).then(res => {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success"
          });
          this.getWorkMateList();
        });
      });
    },
    //获取角色列表
    getMemberRoleList() {
      let auth_type = "";
      let relation_id = "";

      if (this.hasMemberType(2)) {
        auth_type = 2;
        relation_id = this.memberInfo.company_id;
      }

      if (this.hasMemberType(3)) {
        auth_type = 3;
        relation_id = this.memberInfo.merchants_id;
      }

      if (this.hasMemberType(4)) {
        auth_type = 4;
        relation_id = -1;
      }

      let param = {
        role_type: auth_type
      };
      this.post("memberInterfaces/v1.0/getMemberRoles", param).then(res => {
        this.role_list = res.data;
      });
    },
    //    修改用户权限
    updateMemberRole(member) {
      console.log(member)
      this.current_member = member;
      this.update_role_show = true;
    },
    //    修改权限 提交
    submitUpdate() {
      let param = Object.assign({}, this.update_form);
      param.auth_id = this.current_member.memberRoleBean.auth_id;

      if (this.is_Empty(param.role_id)) {
        this.$message("请选择指派角色");
        return;
      }
      if (this.is_Empty(param.auth_id)) {
        this.$message("请选择指派人");
        return;
      }
      this.post("memberInterfaces/v1.0/updateMemberAuth", param).then(res => {
        this.$message("修改成功");
        this.getWorkMateList();
        this.update_role_show = false;
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.member-img {
  width: 60px;
  height: 60px;
  border-radius: 50%
}

.add-btn {
  width: 315px;
  height: 44px;
  background: rgba(69, 142, 246, 1);
  opacity: 1;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/page/me/workmate/index.vue